module.exports = __webpack_public_path__ + "img/symbol_0.e769879f.png";